import React, {Component} from "react";
import {Box, Grid, Typography} from '@deere/fuel-react';
import {List, Dropdown} from "@deere/ux.uxframe-react";

import {MAX_RESULT_PER_PAGE} from "../shared/Constants";
import {Loading} from "../shared/Loading";
import {NoData} from "../shared/NoData";
import PaginationData from "../shared/PaginationData";

class RatingProgramList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            page: 1,
            total: 0,
            perPage: MAX_RESULT_PER_PAGE,
            selectedOption: "Newest-Oldest",
            listToShow: [],
            isLoading: true
        };
    }

    updateComponent() {
        this.setState({
            total: this.props.list.length,
            listToShow: [].sort.call(this.props.list, function (x, y) {
                return y.props.ratingProgram.lastUpdateTs.localeCompare(x.props.ratingProgram.lastUpdateTs);
            }),
            page: 1,
            perPage: MAX_RESULT_PER_PAGE,
            selectedOption: "Newest-Oldest",
            isLoading: false
        });
    }

    componentDidMount() {
        if (!!this.props?.list) {
            this.updateComponent()
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.list !== this.props.list) {
            this.updateComponent()
        }
    }

    setSortingOption(sortMethod) {
        this.setState({selectedOption: sortMethod}, () => {
            this.sortData()
        });
    }

    sortData = () => {
        if (this.state.selectedOption === "Oldest-Newest")
            this.setState({
                listToShow: [].sort.call(this.state.listToShow, function (x, y) {
                    return x.props.ratingProgram.lastUpdateTs.localeCompare(y.props.ratingProgram.lastUpdateTs);
                }),
            });
        else if (this.state.selectedOption === "Newest-Oldest")
            this.setState({
                listToShow: [].sort.call(this.state.listToShow, function (x, y) {
                    return y.props.ratingProgram.lastUpdateTs.localeCompare(x.props.ratingProgram.lastUpdateTs);
                }),
            });

        this.setState({page: 1}); // Resetting page to 1
    };

    getEventHandler = (data) => {
        this.setState({page: data.page});
    }


    render() {
        const pageData = {
            page: this.state.page,
            total: this.state.total,
            perPage: this.state.perPage
        }
        const eventHandler = data => {
            this.getEventHandler(data)
        };
        const {total, page, perPage, isLoading} = this.state;
        const noDataMessage = {
            textLine1: "No results found. Please try a new search term or expanding your filter criteria.",
        }

        return (
            <>
                {total > 0 && (
                    <Grid container>
                        <Grid item xs={6}>
                            <Box display="flex" p={2} justifyContent="flex-start">
                                <Typography size="md" fontWeight="bold" component="p" gutterBottom>
                                    {total} Results
                                </Typography>
                            </Box>
                        </Grid>
                        <Grid item xs={6}>
                            <Box display="flex" p={2} justifyContent="flex-end">
                                <Typography size="md" fontWeight="bold" component="p"
                                            style={{paddingRight: 10, paddingTop: 2}}>
                                    Sort By
                                </Typography>
                                <Dropdown>
                                    <Dropdown.Toggle variant="link" id="dropdown-basic-3" style={{padding: 0}}>
                                        {this.state.selectedOption}
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu>
                                        <Dropdown.Item
                                            onClick={() => {
                                                this.setSortingOption("Newest-Oldest");
                                            }}
                                        >
                                            Newest-Oldest
                                        </Dropdown.Item>
                                        <Dropdown.Item
                                            onClick={() => {
                                                this.setSortingOption("Oldest-Newest");
                                            }}
                                        >
                                            Oldest-Newest
                                        </Dropdown.Item>
                                    </Dropdown.Menu>
                                </Dropdown>
                            </Box>
                        </Grid>

                    </Grid>
                )}
                {isLoading && (
                    <Loading/>
                )}
                {!isLoading && this.state.listToShow.length !== 0 && (
                    <List className="list-group">
                        {this.state.listToShow.slice(
                            (page - 1) * perPage,
                            (page - 1) * perPage + perPage
                        )}
                    </List>
                )}
                {!isLoading && this.state.listToShow.length === 0 && (
                    <NoData noDataMessage={noDataMessage}/>
                )}

                {total > MAX_RESULT_PER_PAGE && (
                    <PaginationData pageData={pageData} onChange={eventHandler}/>
                )}
            </>
        );
    }
}

export default RatingProgramList;
